module.exports = __webpack_public_path__ + "img/153.6b99f7b3.png";